import { useCallback, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ProductSurfaceContext } from '../contexts/productSurfaceContextValue';
import {
  MANDATE_BASE,
  PRIORITIZATION_BASE,
  getProductBaseFromPathname,
  productPath,
} from '../lib/productSurfacePaths';

/** Infer base path from current URL (works without an explicit provider). */
export function useProductSurface() {
  const location = useLocation();
  const ctx = useContext(ProductSurfaceContext);
  const inferredBase = getProductBaseFromPathname(location.pathname);

  const to = useCallback(
    (segment: string) =>
      productPath(ctx.basePath !== PRIORITIZATION_BASE ? ctx.basePath : inferredBase, segment),
    [ctx.basePath, inferredBase]
  );

  return useMemo(
    () => ({
      basePath: ctx.basePath !== PRIORITIZATION_BASE ? ctx.basePath : inferredBase,
      isMandate:
        (ctx.basePath !== PRIORITIZATION_BASE ? ctx.basePath : inferredBase) === MANDATE_BASE,
      to,
    }),
    [ctx.basePath, inferredBase, to]
  );
}
